import HeaderGlobal from '../../components/HeaderGlobal';
import React, { useState } from 'react';
import { createInstitution, updateInstitution } from '../../api/institutions';
import styles from '../../styles/PantallaDeProgramasAcademicos.v2.module.css';
import estudiantesStyles from '../../styles/EstudiantesStyles/Estudiantes.module.css';
import LoaderOverlay from '../../components/LoaderOverlay';
import Sidebar from '../../components/Sidebar';
import InstitutionsTable from './InstitutionsTable';
import NewInstitutionModal from './NewInstitutionModal';
import { usePermissions } from '../../hooks/usePermissions';

const PantallaInstituciones = () => {
  const [openNew, setOpenNew] = useState(false);
  const [editData, setEditData] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  
  // Permisos del módulo Catálogos
  const { canEdit } = usePermissions();
  const puedeEditar = canEdit('Catálogos');

  const handleRegister = () => {
    setEditData(null);
    setOpenNew(true);
  };

  const handleEdit = (row) => {
    setEditData(row);
    setOpenNew(true);
  };

  const handleClose = () => {
    setOpenNew(false);
    setEditData(null);
  };

  const handleSearch = () => {
    // En el futuro se puede filtrar InstitutionsTable usando `query`
    console.log('Buscando instituciones con término:', query);
  };


  const handleSubmit = async (data) => {
    try {
      if (editData) {
        await updateInstitution(editData.id, data);
      } else {
        await createInstitution(data);
      }
      setRefreshKey(k => k + 1);
      setOpenNew(false);
      setEditData(null);
    } catch (err) {
      alert('Error al guardar institución');
    }
  };


  return (
    <div className={styles.mainContainer}>
      <div className={styles.layout}>
        <div className={styles.sidebarColumn}>
          <Sidebar />
        </div>
        <div className={styles.contentColumn}>
          <main className={styles.mainContent}>
            <HeaderGlobal title="Instituciones" />
            <section className={styles.contentArea}>
              <div className={styles.contentWrapper}>
                <LoaderOverlay visible={loading} label="Cargando instituciones..." />
                <LoaderOverlay visible={false} label="Cargando instituciones..." />
                <div className={estudiantesStyles.searchSection}>
                  <div className={estudiantesStyles.searchCard}>
                    <div className={styles.programsSearchRow}>
                      <div className={estudiantesStyles.searchInputGroup}>
                        <svg
                          className={estudiantesStyles.searchIcon}
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                            stroke="#898d8d"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <input
                          type="text"
                          className={estudiantesStyles.searchInput}
                          placeholder="Buscar institución..."
                          aria-label="Buscar institución"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') handleSearch();
                          }}
                        />
                      </div>

                      <button
                        className={styles.buscarButtonProgramas}
                        onClick={handleSearch}
                      >
                        Buscar
                      </button>

                      {puedeEditar && (
                        <button
                          type="button"
                          className={styles.newProgramButton}
                          onClick={handleRegister}
                        >
                          + Nueva Institución
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <InstitutionsTable
                  key={refreshKey}
                  onEdit={handleEdit}
                  onLoadingChange={setLoading}
                />
                {openNew && (
                  <NewInstitutionModal
                    open={openNew}
                    onClose={handleClose}
                    onSubmit={handleSubmit}
                    initialData={editData}
                  />
                )}
              </div>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default PantallaInstituciones;
